import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LegalPages.css';

const TermsAndConditions = () => {
    const navigate = useNavigate();
    return (
        <div className="legal-page">
            <button className="legal-back-btn" onClick={() => navigate(-1)}>
                &larr; Back
            </button>
            <div className="glass-panel">
                <h1>Terms and Conditions</h1>
                <p className="effective-date">Effective Date: 06/08/2026</p>

                <p>Welcome to the <strong>Muthu&Co HRMS Mobile Application</strong> ("Application"), owned and operated by <strong>Muthu & Co</strong>. By accessing, registering, or using this Application, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any part of these Terms, you must discontinue use of the Application immediately.</p>

                <h2>1. Authorized Access</h2>
                <p>The Muthu&Co HRMS Application is intended exclusively for authorized employees and personnel of Muthu & Co. Unauthorized access, use, or distribution of the Application is strictly prohibited.</p>

                <h2>2. Employee Account Responsibility</h2>
                <p>Each employee is responsible for maintaining the confidentiality of their login credentials. Sharing account credentials or allowing unauthorized access to your account is prohibited.</p>

                <h2>3. Official Business Use</h2>
                <p>The Application shall be used solely for official business purposes, including attendance management, employee profile management, internal communication, company announcements, notifications, and other employee-related services provided by Muthu & Co.</p>

                <h2>4. Accurate Information</h2>
                <p>Employees must ensure that all personal, attendance, and employment-related information submitted through the Application is accurate, complete, and up to date. Submission of false or misleading information may result in disciplinary action in accordance with company policies.</p>

                <h2>5. Attendance</h2>
                <p>Attendance records, work location, biometric verification, selfie verification (where applicable), and other attendance-related information submitted through the Application constitute official employment records and are subject to company policies.</p>

                <h2>6. Data Privacy</h2>
                <p>Muthu & Co collects and processes employee information, including personal details, attendance records, location data (where applicable), and employment-related records solely for employee administration, attendance management, regulatory compliance, and official business operations.</p>

                <h2>7. Security</h2>
                <p>Employees shall not:</p>
                <ul>
                    <li>Access unauthorized company information.</li>
                    <li>Modify, reverse engineer, or disrupt the Application.</li>
                    <li>Upload malicious software or harmful content.</li>
                    <li>Misuse confidential company or employee information.</li>
                    <li>Attempt to bypass security mechanisms implemented within the Application.</li>
                </ul>
                <p>Muthu & Co reserves the right to monitor system usage and investigate suspected security violations.</p>

                <h2>8. Intellectual Property</h2>
                <p>The Muthu&Co HRMS Application, including its software, design, content, trademarks, logos, source code, and related intellectual property, is the exclusive property of Muthu & Co. Unauthorized reproduction, distribution, modification, or commercial use is strictly prohibited.</p>

                <h2>9. Suspension or Termination</h2>
                <p>Muthu & Co reserves the right to suspend or terminate user access without prior notice in cases of policy violations, security concerns, misuse of company resources, fraudulent activities, or termination of employment.</p>

                <h2>10. Limitation of Liability</h2>
                <p>Muthu & Co shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from the use of, or inability to use, the Application, except where required by applicable law.</p>

                <h2>11. Changes to the Terms</h2>
                <p>Muthu & Co reserves the right to modify these Terms and Conditions at any time. Continued use of the Application after such modifications constitutes acceptance of the revised Terms.</p>

                <h2>12. Governing Law</h2>
                <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of the Republic of India.</p>

                <div className="legal-contact-box">
                    <strong>Company:</strong> Muthu & Co<br />
                    <strong>Application:</strong> Muthu&Co HRMS<br />
                    <strong>Email:</strong> <a href="mailto:p2pswap786@gmail.com">p2pswap786@gmail.com</a>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;